<template>
    <address-picker
            :customer="customer"
            name="address"
            ref="picker"
            :initial-value="initialValue"
            address-type="shipping"
    >
        <div uk-grid class="uk-grid-small" slot="form-fields">
            <div class="uk-width-1-1">
                <p class="rr-checkout-accordion__content-title">
                    {{ $t('rubinred.ecommerce.orders.checkout.step-2.shipping_address') }}
                </p>
            </div>
            <slot></slot>
        </div>
    </address-picker>
</template>

<script>
  export default {
    inject: ['registerHandler'],
    props: {
      customer: {
        type: Boolean,
        required: true,
      },
      slug: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        initialValue: this.$store.state.checkout.shipping.address,
      }
    },
    created() {
      this.registerHandler(this);
    },
    methods: {
      validate() {
        return this.$refs.picker.validate();
      },
      getData() {
        return this.$refs.picker.getValues();
      }
    },
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/ecommerce/assets/js/components/checkout/shipping/ExpressCourierHandler.vue